(function () {
  "use strict";

  if (window.__OKMO_REFLOW_LOADED__) return;
  window.__OKMO_REFLOW_LOADED__ = true;

  var VERSION = "1.4.0";
  var SITE_ID = "okmotech-shopify-test";
  var CREATIVE_ID = "okmo-200ah-bestseller-v1";
  var EVENT_ENDPOINT = "https://reflow.quickerchat.com/api/events";
  var CREATIVE_URL = "https://cdn.shopify.com/s/files/1/0550/0459/4236/files/okmo-return-page-product-recommendation-v1.png?v=1786002420";
  var PRODUCT_URL = "/products/okmo-12v-200ah-mini-lifepo4-battery-for-rv-solar-marine-off-grid-power";
  var SEEN_KEY = "okmo_rf_seen_v3";
  var LANDING_KEY = "okmo_rf_landing_v3";
  var SESSION_KEY = "okmo_rf_session_v2";
  var VISITOR_KEY = "okmo_rf_visitor_v1";
  var HISTORY_ARMED_KEY = "okmo_rf_history_armed_v3";
  var RETURN_READY_KEY = "okmo_rf_return_ready_v3";
  var STAGE_PARAM = "rf_nav";
  var ENABLED_COOKIE = "okmo_rf_lifecycle_test_v1";
  var PURCHASE_COOKIE = "okmo_rf_purchased_v1";
  var CART_STATE_KEY = "okmo_rf_cart_state_v1";

  var activeCreativeId = CREATIVE_ID;
  var activeProductUrl = PRODUCT_URL;
  var lifecycleState = "unknown";
  var cartItemCount = 0;
  var lifecycleReady = false;

  var params = new URLSearchParams(window.location.search);
  var userAgent = navigator.userAgent || "";
  var forceTest = params.get("rf_test") === "1" &&
    /\.shopifypreview\.com$/i.test(window.location.hostname);
  var isMobile = /Android|iPhone|iPad|iPod/i.test(userAgent) || window.innerWidth <= 820;
  var isFacebookInApp = /FBAN|FBAV|FB_IAB/i.test(userAgent);
  var isNavigationStage = params.get(STAGE_PARAM) === "1";

  // Production lifecycle recovery is enabled for every mobile browser.
  // Desktop remains excluded because the interaction is designed around
  // native mobile back buttons and edge-swipe navigation.
  if (!forceTest && !isMobile) return;
  if (!forceTest && window.Shopify && window.Shopify.designMode) return;

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return "rf-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
  }

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (_) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (_) {}
  }

  function readCookie(name) {
    var prefix = name + "=";
    return document.cookie.split(";").map(function (part) { return part.trim(); }).filter(function (part) {
      return part.indexOf(prefix) === 0;
    }).map(function (part) { return decodeURIComponent(part.slice(prefix.length)); })[0] || "";
  }

  function setCookie(name, value, maxAge) {
    document.cookie = name + "=" + encodeURIComponent(value) + "; Path=/; Max-Age=" + maxAge + "; SameSite=Lax";
  }

  var visitorId = storageGet(window.localStorage, VISITOR_KEY) || randomId();
  var sessionId = storageGet(window.sessionStorage, SESSION_KEY) || randomId();
  storageSet(window.localStorage, VISITOR_KEY, visitorId);
  storageSet(window.sessionStorage, SESSION_KEY, sessionId);
  setCookie(VISITOR_KEY, visitorId, 60 * 60 * 24 * 180);
  setCookie(SESSION_KEY, sessionId, 60 * 60 * 24);
  setCookie(ENABLED_COOKIE, "1", 60 * 60 * 24);

  var os = /iPhone|iPad|iPod/i.test(userAgent)
    ? "iOS"
    : /Android/i.test(userAgent)
      ? "Android"
      : forceTest
        ? "Test"
        : "Desktop";
  var inApp = isFacebookInApp ? "Facebook" : forceTest ? "Test" : "Other";
  var browser = /CriOS|Chrome/i.test(userAgent)
    ? "Chrome"
    : /Safari/i.test(userAgent)
      ? "Safari"
      : "WebView";
  var source = params.get("utm_source") || "direct";
  var campaign = params.get("utm_campaign") || "unknown";
  var content = params.get("utm_content") || "unknown";

  function eventPayload(eventName, metadata) {
    return {
      siteId: SITE_ID,
      eventName: eventName,
      visitorId: visitorId,
      sessionId: sessionId,
      creativeId: activeCreativeId,
      source: source,
      campaign: campaign,
      content: content,
      os: os,
      browser: browser,
      inApp: inApp,
      value: arguments.length > 2 && Number.isFinite(Number(arguments[2])) ? Number(arguments[2]) : 0,
      metadata: Object.assign(
        {
          sdkVersion: VERSION,
          pagePath: window.location.pathname,
          pageTitle: document.title
        },
        metadata || {}
      )
    };
  }

  function track(eventName, metadata, value) {
    var body = JSON.stringify(eventPayload(eventName, metadata, value));
    try {
      if (navigator.sendBeacon) {
        var queued = navigator.sendBeacon(
          EVENT_ENDPOINT,
          new Blob([body], { type: "text/plain;charset=UTF-8" })
        );
        if (queued) return;
      }
      fetch(EVENT_ENDPOINT, {
        method: "POST",
        mode: "no-cors",
        credentials: "omit",
        keepalive: true,
        body: body
      }).catch(function () {});
    } catch (_) {}
  }

  function loadLifecycle() {
    if (readCookie(PURCHASE_COOKIE) === "1") {
      lifecycleState = "purchased";
      lifecycleReady = true;
      return Promise.resolve();
    }
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        cartItemCount = cart && Number.isFinite(Number(cart.item_count)) ? Number(cart.item_count) : 0;
        lifecycleState = cartItemCount > 0 ? "cart" : "new";
        storageSet(window.sessionStorage, CART_STATE_KEY, lifecycleState);
        track("cart_state", { state: lifecycleState, itemCount: cartItemCount }, cartItemCount);
      })
      .catch(function () {
        lifecycleState = "unknown";
        track("cart_state", { state: lifecycleState, itemCount: 0 }, 0);
      })
      .then(function () { lifecycleReady = true; });
  }

  function refreshLifecycle() {
    lifecycleReady = false;
    lifecyclePromise = loadLifecycle();
    return lifecyclePromise;
  }

  var lifecyclePromise = loadLifecycle();

  if (!storageGet(window.sessionStorage, LANDING_KEY)) {
    storageSet(window.sessionStorage, LANDING_KEY, "1");
    track("landing_view", { forcedTest: forceTest });
  }

  if (storageGet(window.sessionStorage, SEEN_KEY)) return;

  var overlay = null;
  var overlayOpen = false;
  var ctaClicked = false;
  var dismissTracked = false;
  var previousOverflow = "";

  function trackDismiss(method) {
    if (dismissTracked || ctaClicked) return;
    dismissTracked = true;
    track("reflow_dismissed", { method: method });
  }

  function releaseAndExit(method) {
    trackDismiss(method);
    storageSet(window.sessionStorage, RETURN_READY_KEY, "0");
    if (overlay) overlay.remove();
    overlayOpen = false;
    document.documentElement.style.overflow = previousOverflow;
    window.history.back();
  }

  function showReturnPage() {
    if (!lifecycleReady) {
      lifecyclePromise.then(showReturnPage);
      return;
    }
    // The lifecycle offer is only for visitors who have not added anything.
    // Cart and purchased visitors must leave normally; unknown state fails closed.
    if (lifecycleState !== "new") return;
    if (overlayOpen || storageGet(window.sessionStorage, SEEN_KEY)) return;

    storageSet(window.sessionStorage, SEEN_KEY, "1");
    overlayOpen = true;
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
    track("return_triggered");

    overlay = document.createElement("section");
    overlay.id = "okmo-reflow-overlay";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Recommended product");
    overlay.innerHTML =
      '<style>' +
      '#okmo-reflow-overlay{position:fixed;z-index:2147483647;inset:0;background:#0b151f;display:flex;align-items:stretch;justify-content:center;overflow:hidden}' +
      '#okmo-reflow-overlay *{box-sizing:border-box}' +
      '#okmo-reflow-overlay .okmo-rf-link{display:block;width:100%;height:100%;max-width:520px;margin:0 auto;background:#0b151f;text-decoration:none}' +
      '#okmo-reflow-overlay .okmo-rf-image{display:block;width:100%;height:100%;object-fit:cover;object-position:center}' +
      '#okmo-reflow-overlay .okmo-rf-close{position:absolute;z-index:2;top:max(14px,env(safe-area-inset-top));right:14px;width:44px;height:44px;border:1px solid rgba(255,255,255,.75);border-radius:999px;background:rgba(5,13,19,.72);color:#fff;font:400 30px/40px Arial,sans-serif;text-align:center;padding:0;box-shadow:0 4px 18px rgba(0,0,0,.28)}' +
      '#okmo-reflow-overlay .okmo-rf-close:focus-visible{outline:3px solid #9ad34b;outline-offset:2px}' +
      '</style>' +
      '<button class="okmo-rf-close" type="button" aria-label="Close and return">&times;</button>' +
      '<a class="okmo-rf-link" href="' + activeProductUrl + '?rf_creative=' + encodeURIComponent(activeCreativeId) + '">' +
      '<img class="okmo-rf-image" src="' + CREATIVE_URL + '" alt="OKMO 12V 200Ah Mini LiFePO4 recommended product">' +
      '</a>';

    document.body.appendChild(overlay);

    var image = overlay.querySelector(".okmo-rf-image");
    var impressionTracked = false;
    var trackImpression = function () {
      if (impressionTracked) return;
      impressionTracked = true;
      track("reflow_impression");
    };
    image.addEventListener("load", trackImpression, { once: true });
    if (image.complete && image.naturalWidth > 0) trackImpression();

    overlay.querySelector(".okmo-rf-link").addEventListener("click", function () {
      ctaClicked = true;
      track("reflow_cta_click", { destination: activeProductUrl, lifecycleState: lifecycleState });
    });

    overlay.querySelector(".okmo-rf-close").addEventListener("click", function () {
      releaseAndExit("close_button");
    });
  }

  window.addEventListener("pagehide", function () {
    if (overlayOpen) trackDismiss("browser_back");
  });

  window.OKMOReflow = {
    version: VERSION,
    trigger: showReturnPage,
    track: track
  };

  function isReturnedEntry() {
    return !isNavigationStage &&
      storageGet(window.sessionStorage, HISTORY_ARMED_KEY) === "1" &&
      storageGet(window.sessionStorage, RETURN_READY_KEY) === "1";
  }

  function showOnRealHistoryReturn() {
    if (!isReturnedEntry()) return;
    storageSet(window.sessionStorage, RETURN_READY_KEY, "0");
    // Cart state can change after the landing page loads. Re-read it at the
    // exact return moment so a newly added item suppresses the reflow page.
    refreshLifecycle().then(function () {
      if (lifecycleState !== "new") {
        window.history.back();
        return;
      }
      showReturnPage();
    });
  }

  // Facebook's iOS/Android toolbar can ignore same-document pushState entries.
  // A single same-origin document navigation creates a real WebView history entry.
  // Returning from that entry restores this page, where pageshow renders the offer.
  window.addEventListener("pageshow", showOnRealHistoryReturn);

  if (isNavigationStage) {
    storageSet(window.sessionStorage, HISTORY_ARMED_KEY, "1");
    storageSet(window.sessionStorage, RETURN_READY_KEY, "1");
    return;
  }

  if (isReturnedEntry()) {
    showOnRealHistoryReturn();
    return;
  }

  storageSet(window.sessionStorage, HISTORY_ARMED_KEY, "1");
  storageSet(window.sessionStorage, RETURN_READY_KEY, "0");
  var navigationScheduled = false;
  function createRealHistoryEntry() {
    if (navigationScheduled) return;
    navigationScheduled = true;
    window.setTimeout(function () {
      var navigationUrl = new URL(window.location.href);
      navigationUrl.searchParams.set(STAGE_PARAM, "1");
      window.location.assign(navigationUrl.toString());
    }, 400);
  }

  // Wait until the document is visibly established. Navigating during startup can
  // be coalesced as a redirect and won't create a native WebView back entry.
  if (document.readyState === "complete") {
    createRealHistoryEntry();
  } else {
    window.addEventListener("pageshow", createRealHistoryEntry, { once: true });
  }
})();
